(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-v2"] && !Shopify.designMode) return;
  try {
    
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  }
  customElements.define('quantity-input', QuantityInput);

  class VariantRadios extends HTMLElement {
    constructor() {
      super();
        this.addEventListener('change', this.onVariantChange.bind(this));
        // Trigger on load to ensure initial variant/media is synced
        this.onVariantChange();
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updateURL();
        
        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updatePrice();
            this.updateVariantInput();
            
            if (this.currentVariant.available) {
                this.toggleAddButton(false, 'Add to Cart', false);
            } else {
                this.toggleAddButton(true, 'Sold out', false);
            }
        }
    }

    updateVariantInput() {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const input = productForm.querySelector('input[name="id"]');
        if (input) {
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('fieldset'), (fieldset) => {
            const checkedInput = fieldset.querySelector('input:checked');
            return checkedInput ? checkedInput.value : '';
        });
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant || !this.currentVariant.featured_media) return;
        scrollToSlide(this.currentVariant.featured_media.id);
    }
    
    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updatePrice() {
        if (!this.currentVariant) return;

        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `price-${this.dataset.section}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                if (source && destination) destination.innerHTML = source.innerHTML;

                const price = document.getElementById(`ProductInfo-${this.dataset.section}`).querySelector('.product-v2-price');
                if (price) price.classList.remove('visibility-hidden');
            });
    }

    /* Simplified variant data retrieval */
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        return this.variantData;
    }
    
    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
        if (!button) return;
        button.querySelector('span').textContent = 'Unavailable';
        button.setAttribute('disabled', true);
    }

    toggleAddButton(disable, text, modifyClass) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;
        const addButtonText = addButton.querySelector('span');
        if (!addButtonText) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            if (text) addButtonText.textContent = text;
        }
    }
  }
  customElements.define('variant-radios', VariantRadios);

  class ProductForm extends HTMLElement {
      constructor() {
          super();
          this.form = this.querySelector('form');
          this.form.querySelector('[name=id]').disabled = false; 
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }
      
      onSubmitHandler(evt) {
          evt.preventDefault();
          const submitButton = this.querySelector('[type="submit"]');
          if (submitButton.classList.contains('loading')) return;

          this.handleErrorMessage(); // Clear previous errors
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
          
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          const formData = new FormData(this.form);
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                 if (response.status) {
                    this.handleErrorMessage(response.description);
                    return;
                }
                
                // Success - trigger cart drawer or redirect
                 window.location.href = '/cart'; // Default to car for safety
            })
            .catch((e) => { console.error(e); })
            .finally(() => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
            });
      }
      
      handleErrorMessage(errorMessage = false) {
        // Logic to show error message
        if(errorMessage) alert(errorMessage);
      }
  }
  customElements.define('product-form', ProductForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
